import styled from "styled-components";
import ReactModal from "react-overlays/Modal";
import { constants, theme } from "../../layout";

export const Backdrop = styled.div`
  position: fixed;
  z-index: 99;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${theme.modal.backdrop};
  opacity: 0.8;
`;

export const Modal = styled(ReactModal)`
  position: fixed;
  z-index: 99;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${theme.modal.background};
  border-radius: ${constants.radius.view}px;
  outline: 0;
`;
